import styles from './ProgressBar.module.css';

export const ProgressBar = () => {
  return (
    <div className="relative h-1 w-full overflow-hidden rounded bg-indigo bg-opacity-40">
      <div className={styles.progressBar}></div>
    </div>
  );
};
